import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TweenMax, Linear } from 'gsap';
import { Application, extras, Container } from 'pixi.js';

const propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    scale: PropTypes.number,
    spritesCount: PropTypes.number,
    animations: PropTypes.shape({}),
    fps: PropTypes.number,
    onReady: PropTypes.func,
};

const defaultProps = {
    width: 200,
    height: 200,
    scale: 0.5,
    spritesCount: 8,
    animations: {
        // step_1: [0, 270],
        // step_2: [270, 540],
        // step_3: [540, 750],
        // step_4: [750, 960],
        // step_5: [960, 1230],
        // step_6: [1230, 1440],
        step_1: [0, 90],
        step_2: [90, 216],
        step_3: [216, 287],
        step_4: [287, 380],
        step_5: [380, 490],
        step_6: [490, 576],
    },
    fps: 24,
    onReady: null,
};

class HumAnimation extends Component {
    constructor(props) {
        super(props);

        this.onLoad = this.onLoad.bind(this);

        this.refCanvas = null;

        this.app = null;
        this.animationsTextures = null;
        this.animationsSprites = null;
        this.tweens = null;
    }

    componentDidMount() {
        const { spritesCount, width, height } = this.props;
        this.app = new Application({
            width,
            height,
            resolution: window.devicePixelRatio || 1,
            view: this.refCanvas,
            autoStart: false,
            sharedTicker: false,
            transparent: true,
            roundPixels: true,
        });

        for (let i = 0; i < spritesCount; i += 1) {
            this.app.loader.add(`sprites-${i}`, `/img/animation/hum-${i}.json`);
        }

        this.app.loader.load(this.onLoad);
    }

    componentWillUnmount() {
        if (this.app !== null) {
            this.app.destroy();
            this.app = null;
        }

        if (this.animationsTextures !== null) {
            Object.keys(this.animationsTextures).forEach((name) => {
                this.animationsTextures[name].destroy();
            });
            this.animationsTextures = null;
        }

        if (this.animationsSprites !== null) {
            Object.keys(this.animationsSprites).forEach((name) => {
                this.animationsSprites[name].destroy();
            });
            this.animationsSprites = null;
        }

        if (this.tweens !== null) {
            Object.keys(this.tweens).forEach((name) => {
                this.tweens[name].kill();
            });
            this.tweens = null;
        }
    }

    onLoad() {
        const { onReady } = this.props;
        // Get textures;
        const resources = this.app.loader.resources;
        const textures = [];
        Object.keys(resources).forEach((resourceName) => {
            if (resourceName.match(/_image$/)) {
                return;
            }
            const resource = resources[resourceName];
            Object.keys(resource.textures).forEach((textureName) => {
                const texture = resource.textures[textureName];
                const index = parseInt(textureName.match(/_([0-9]+)\.png$/)[1], 10);
                textures[index] = texture;
            });
        });

        this.buildStage(textures);

        if (onReady !== null) {
            onReady(this.tweens);
        }
    }

    onAnimationStart(name) {

    }

    onAnimationComplete(name) {

    }

    buildStage(textures) {
        const { width, height, scale } = this.props;

        // Build Textures
        this.animationsTextures = this.buildTextures(textures);

        // Build sprites
        this.animationsSprites = this.buildSprites(this.animationsTextures);

        // Build tweens
        this.tweens = this.buildTweens(this.animationsSprites);

        // Add to stage
        Object.keys(this.animationsSprites).forEach((name) => {
            const container = new Container();
            const sprite = this.animationsSprites[name];
            sprite.visible = false;
            sprite.x = -Math.round(sprite.width / 2);
            sprite.y = -Math.round(sprite.height / 2);
            container.x = Math.round(width / 2);
            container.y = Math.round(height / 2);
            container.addChild(sprite);
            container.scale.set(scale, scale);
            this.app.stage.addChild(container);
        });
    }

    buildTextures(textures) {
        const { animations } = this.props;
        return Object.keys(animations).reduce((animTextures, name) => {
            const animationFrames = animations[name];
            return {
                ...animTextures,
                [name]: textures.slice(animationFrames[0], animationFrames[1]),
            };
        }, {});
    }

    // eslint-disable-next-line class-methods-use-this
    buildSprites(textures) {
        return Object.keys(textures).reduce((sprites, name) => {
            const frames = textures[name];
            return {
                ...sprites,
                [name]: new extras.AnimatedSprite(frames),
            };
        }, {});
    }

    buildTweens(animations) {
        const { fps } = this.props;
        return Object.keys(animations).reduce((sprites, name) => {
            const sprite = animations[name];
            const progressObject = {
                frameIndex: 0,
            };
            const duration = (1 / fps) * sprite.totalFrames;
            return {
                ...sprites,
                [name]: TweenMax.fromTo(progressObject, duration, {
                    frameIndex: 0,
                }, {
                    ease: Linear.easeNone,
                    frameIndex: sprite.totalFrames - 1,
                    onStart: () => {
                        sprite.visible = true;
                        this.onAnimationStart(name);
                    },
                    onUpdate: () => {
                        sprite.gotoAndStop(Math.round(progressObject.frameIndex));
                    },
                    onComplete: () => {
                        sprite.visible = false;
                        this.onAnimationComplete(name);
                    },
                }).paused(true),
            };
        }, {});
    }

    tick() {
        if (this.app !== null) {
            this.app.render();
        }
    }

    render() {
        const {
            width,
            height,
        } = this.props;
        const style = {
            width,
            height,
        };
        return (
            <canvas
                style={style}
                ref={(ref) => { this.refCanvas = ref; }}
            />
        );
    }
}

HumAnimation.propTypes = propTypes;
HumAnimation.defaultProps = defaultProps;

export default HumAnimation;



// WEBPACK FOOTER //
// ./components/partials/HumAnimation.jsx